import { createAction } from '@reduxjs/toolkit';

import { FeedBackBody } from '../../client';

export const sendFeedBackAct = createAction<{ message: FeedBackBody }>('[feedback] send feedback');
